import type {
  DetailedHTMLProps,
  FC,
  HTMLAttributes,
  PropsWithChildren,
} from 'react';
import { Container } from './style';

export interface BadgeProps extends DetailedHTMLProps<
  HTMLAttributes<HTMLSpanElement>,
  HTMLSpanElement
> {
  type?: 'success' | 'fail';
}

const Badge: FC<PropsWithChildren<BadgeProps>> = ({ children, ...props }) => {
  return <Container {...props}>{children}</Container>;
};

export default Badge;
